/** Names of the events carried on the app-wide `mitt` emitter. Payload types live in `GlobalAppEvents`. */
export enum GlobalAppEventEnum {
  RESET_PAGINATION = "RESET_PAGINATION",
  PAGINATION_CHANGE = "PAGINATION_CHANGE",
  START_DRAG = "START_DRAG",
  SET_PAGINATION_TO_RIDE = "SET_PAGINATION_TO_RIDE",
  RESIZE_RIDE_MAP = "RESIZE_RIDE_MAP",
  RESIZE_STATION_ROUTE_MAP = "RESIZE_STATION_ROUTE_MAP",
  RESIZE_COURSE_MAP = "RESIZE_COURSE_MAP",
  RESIZE_PASSENGER_MAP = "RESIZE_PASSENGER_MAP",
  RESIZE_STATIONS_MAP = "RESIZE_STATIONS_MAP",
  RESIZE_AREAS_MAP = "RESIZE_AREAS_MAP",
  INIT_BOOKINGS_POLLING = "INIT_BOOKINGS_POLLING",
  INIT_BOOKINGS_DATE_TIME_UPDATE_POLLING = "INIT_BOOKINGS_DATE_TIME_UPDATE_POLLING",
  ABORT_BOOKINGS_POLLING = "ABORT_BOOKINGS_POLLING",
  PROCESS_COMPLETED = "PROCESS_COMPLETED",
  /** A station was just created outside the screen that shows stations — "Add station here" on a map. */
  STATION_CREATED = "STATION_CREATED",
}
